import {useFilterProviders} from '@github-ui/shared-filter-providers/providers/use-filter-providers'

import {useSavedViewIssueStatusSearchOptions} from '../contexts/SavedViewIssueStatusContext'

interface UseSavedViewFilterProvidersOptions {
  owner: string
  repo: string
}

export function useSavedViewFilterProviders({owner, repo}: UseSavedViewFilterProvidersOptions) {
  const issueStatusSearchOptions = useSavedViewIssueStatusSearchOptions()

  return useFilterProviders({
    repositoryScope: owner && repo ? `${owner}/${repo}` : undefined,
    isOrgScope: true,
    isIssueFieldsEnabled: true,
    isIssueSearchScope: true,
    issueStatusSearchOptions,
  })
}
